(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('AddPropertyValueController', AddPropertyValueController);

    AddPropertyValueController.$inject = ['$scope', '$uibModalInstance', 'msgdata'];

    function AddPropertyValueController($scope, $uibModalInstance, msgdata) {
        var vm = this;
        vm.save = save;
        vm.toggleAll = toggleAll;
        vm.toggleItem = toggleItem;
        vm.allChecked = false;

        vm.delList = angular.copy(msgdata.delTableList);
        angular.forEach(vm.delList, function(item) {
            item.selected = false;
        });

        function toggleAll() {
            vm.allChecked = !vm.allChecked;
            angular.forEach(vm.delList, function(item) {
                item.selected = vm.allChecked;
            });
        }

        function toggleItem(item) {
            item.selected = !item.selected;
            var allSelected = vm.delList.length > 0;
            angular.forEach(vm.delList, function(itm) {
                if (!itm.selected) {
                    allSelected = false;
                }
            });
            vm.allChecked = allSelected;
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss();
        };

        function save() {
            var selectedItems = [];
            angular.forEach(vm.delList, function(item) {
                if (item.selected) {
                    selectedItems.push(item);
                }
            });
            $uibModalInstance.close(selectedItems);
        }
    }
})();
